// The server URL for testing mTLS handshake.
export const JS_TEST_SERVER_URL = 'https://127.0.0.1:3000';

// The base IP address of the wireless access point's HTTP API.
export const BASE_IPV4_ADDRESS = 'https://172.17.2.1';
export const EVSE_API_USERNAME = 'sehome';
export const EVSE_FACTORY_PIN_CODE = '123456';

// WiFi reconnection buffer time.
export const WIFI_RECONNECT_TIMEOUT_MS = 6_000;

// EVSE device reboot time after Wi-Fi configuration
export const EVSE_REBOOT_TIMEOUT_MS = 12_000;

export const HISTORY_CHART_OPTIONS = {
  height: 320,
  color: '#9B51E0',
  fillGradientStart: 'rgba(155, 81, 224, 0.3)',
  fillGradientStop: 'rgba(155, 81, 224, 0)',
};
